<select #select [class]="'block w-full px-3 py-2 text-base font-normal bg-white border rounded placeholder-slate-400 focus:outline-none ' + styles" [ngClass]="{'simple': isSimple, 'withImage': haveImage, 'invalid': hasErrors, 'options-only': optionsOnly, 'h-10': !optionsOnly, 'auto-open': autoOpen}" [(ngModel)]="itemSelected" [ngModelOptions]="{standalone: true}" (change)="changeEventEmitter.emit(itemSelected)" [disabled]="disabled!" [required]="required!">
    @if (placeholder) {
        <option [value]="''" [selected]="id === ''">
            {{ placeholder }}
        </option>
    }
    @if (elements!.length > 0) {
        @for (item of elements; track $index) {
            <option [value]="item.id" [selected]="id === item.id">
                <label>{{ image ? item.image + " " + item.name : translateValue ? literalService.get(item.id.toString().toLowerCase(), true) : getValueToShow(item) }}</label>
            </option>
        }
    }
    @if (hasErrors) {
        <img [src]="images.error" class="absolute mr-8 w-6" alt="errorIcon" />
    }
</select>
@if (hasErrors) {
    <label class="text-xs hasErrors">{{ error }}</label>
}